import React from 'react'
import {
  Radio, Row, Col, Select,
} from 'antd'

import { useIsSmallDevice } from '../../hookreducer/hooks'

import __ from '../../languages/parser'

import {
  COLOR_URLS, PASTILLES_URL,
} from '../../static/url'

const { Option } = Select

const colors = {
  wood: ['black', 'white', 'oak', 'birch'],
  metal: ['black', 'white', 'brass'],
}

const SwatchOption = ({ color }) => (
  <Row>
    <Col span={6} style={{ textAlign: 'center' }}>
      <img src={COLOR_URLS[color]} alt={__(color)} style={{ height: '24px' }} />
    </Col>
    <Col span={18}>
      <span style={{
        marginLeft: '1em', fontWeight: 500,
      }}
      >
        {__(color)}
      </span>
    </Col>
  </Row>
)

const SwatchContentSelect = ({ color, type = 'metal', setColor }) => (
  <Row style={{ width: '100%' }}>
    <Select value={color} style={{ width: '100%', marginBottom: '0.4em' }} onChange={(evt) => { setColor(evt) }} dropdownStyle={{ zIndex: 10000 }}>
      {colors[type].map((el) => <Option key={el}><SwatchOption color={el} /></Option>)}
    </Select>
  </Row>
)

const SwatchContent = ({ color }) => (
  <Row style={{ width: '100%' }}>
    <Col span={4} style={{ textAlign: 'center' }}>
      <img src={COLOR_URLS[color]} alt={__(color)} style={{ height: '28px', marginRight: '10px', marginTop: '-2px' }} />
    </Col>
    <Col span={20} style={{ fontWeight: '500' }}>
      <span>{__(color).toUpperCase()}</span>
    </Col>
  </Row>
)


const StyleMenuSmall = ({
  metalColor, woodColor, setMetalColor, setWoodColor,
}) => {
  const blocStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    maxHeight: '84px',
    borderRadius: '12px',
    fontSize: '0.8em',
  }

  const blocStyleButtons = {
    marginTop: '4px',
    display: 'flex',
    flexDirection: 'row',
  }
  return (
    <Row>
      <Col offset={1} span={23}>
        <div style={{
          overflowX: 'scroll',
          overflowY: 'hidden',
          display: 'flex',
          flexDirection: 'row',
          paddingBottom: '10px',
          height: '74px',
        }}
        >
          <div style={{ ...blocStyle, width: '48%' }}>
            <div>
              {__('Wall bases')}

            </div>
            <div style={blocStyleButtons}>
              <SwatchContentSelect color={metalColor} type="metal" setColor={setMetalColor} />
            </div>
          </div>

          <div style={{ ...blocStyle, width: '48%' }}>
            <div>
              {__('Boards')}

            </div>
            <div style={blocStyleButtons}>
              <SwatchContentSelect color={woodColor} type="wood" setColor={setWoodColor} />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  )
}


const StyleMenu = ({
  metalColor, woodColor, setMetalColor, setWoodColor,
}) => {
  const buttonStyle = {
    width: '100%',
    marginBottom: '0.4em',
  }

  return (
    <>
      <Row style={{ marginBottom: '2em' }}>
        <span className="maker-subtitle">{__('Wall bases Color')}</span>
        <Radio.Group value={metalColor} buttonStyle="solid" onChange={(e) => setMetalColor(e.target.value)}>
          <Radio.Button
            value="black"
            style={buttonStyle}
          >
            <SwatchContent color="black" />
          </Radio.Button>
          <Radio.Button value="white" style={buttonStyle}><SwatchContent color="white" /></Radio.Button>
          <Radio.Button value="brass" style={buttonStyle}><SwatchContent color="brass" /></Radio.Button>
        </Radio.Group>
      </Row>
      <Row>
        <span className="maker-subtitle">{__('Boards Finishes')}</span>
        <Radio.Group value={woodColor} buttonStyle="solid" onChange={(e) => setWoodColor(e.target.value)}>
          <Radio.Button value="black" style={buttonStyle}><SwatchContent color="black" /></Radio.Button>
          <Radio.Button value="white" style={buttonStyle}><SwatchContent color="white" /></Radio.Button>
          <Radio.Button value="birch" style={buttonStyle}><SwatchContent color="birch" /></Radio.Button>
          <Radio.Button value="oak" style={buttonStyle}><SwatchContent color="oak" /></Radio.Button>
        </Radio.Group>
      </Row>
      <Row style={{ width: '100%' }}>
        <Col offset={1} span={23}>
          <div style={{ padding: '1.4em', textAlign: 'center' }}>
            <img src={PASTILLES_URL[metalColor][woodColor]} style={{ width: '80%' }} alt={`exemple ${__(metalColor)} ${__(woodColor)}`} />
          </div>
        </Col>
      </Row>

    </>
  )
}

const StyleContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <StyleMenuSmall {...props} /> : <StyleMenu {...props} />
}

export default StyleContainer
